// FieldIQ — Static sample data (network contacts, activities)

export const NETWORK_KEY = "fieldiq_network_imported";

const NETWORK_CONTACTS = [
  {
    id: "nc-1",
    initials: "MS",
    name: "Mike Senior",
    relation: "Brother",
    meta: "LD4 · Voted in last 4 elections",
    tags: [
      { label: "High Propensity", color: "emerald" },
      { label: "Family", color: "cyan" },
    ],
    gradient: "from-cyan-400 to-blue-500",
    phone: "+14805550101",
    email: "—",
  },
  {
    id: "nc-2",
    initials: "JK",
    name: "Jennifer Klein",
    relation: "Coworker",
    meta: "LD4 · Skipped 2024 primary",
    tags: [{ label: "Needs nudge", color: "amber" }],
    gradient: "from-purple-400 to-fuchsia-500",
    phone: "+14805550102",
    email: "—",
  },
  {
    id: "nc-3",
    initials: "TM",
    name: "Tom Martinez",
    relation: "Neighbor",
    meta: "LD4 · No primary vote since 2020",
    tags: [
      { label: "Low Propensity", color: "rose" },
      { label: "High Impact", color: "cyan" },
    ],
    gradient: "from-emerald-400 to-teal-500",
    phone: "+14805550103",
    email: "—",
  },
  {
    id: "nc-4",
    initials: "DP",
    name: "Dave Patel",
    relation: "College friend",
    meta: "CD-1 · Active voter",
    tags: [{ label: "Different District", color: "slate" }],
    gradient: "from-orange-400 to-amber-500",
    phone: "+14805550104",
    email: "—",
  },
];

const ACTIVITIES = [
  {
    id: "ev-1",
    type: "event",
    subtype: "meeting",
    title: "LD4 Monthly Meeting",
    date: "2026-05-01",
    time: "6:30 PM",
    location: "Mesa Arts Center, Room 204",
    address: "1 E Main St, Mesa, AZ 85201",
    description:
      "Monthly precinct committee meeting. Agenda: candidate endorsements and Q3 canvassing plan. Bring your voter contact reports.",
    status: "upcoming",
  },
  {
    id: "ev-2",
    type: "event",
    subtype: "vote",
    title: "School Board Public Vote",
    date: "2026-04-29",
    time: "5:00 PM",
    location: "Mesa Unified SD Headquarters",
    address: "63 E Main St, Mesa, AZ 85201",
    description:
      "Public vote on curriculum transparency policy. PC presence encouraged to demonstrate community support.",
    status: "upcoming",
  },
  {
    id: "wk-1",
    type: "walk",
    title: "Precinct Route — PC 04-03",
    date: "2026-04-28",
    time: "9:00 AM",
    location: "E Baseline Rd & S Greenfield Rd, Mesa",
    address: "E Baseline Rd & S Greenfield Rd, Mesa, AZ",
    description:
      "10 door targets. Focus: voter contact and issue survey. Bring water — high of 88°F.",
    status: "upcoming",
    doors: 10,
    completed: 0,
  },
  {
    id: "wk-2",
    type: "walk",
    title: "Precinct Route — PC 04-07",
    date: "2026-04-26",
    time: "10:00 AM",
    location: "W University Dr & N Stapley Dr, Mesa",
    address: "W University Dr & N Stapley Dr, Mesa, AZ",
    description: "8 door targets. Follow-up contacts from last week's walk.",
    status: "completed",
    doors: 8,
    completed: 8,
  },
];
